module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Clipboard-list-3db773d2fb00600e8e1de0918c589baa.svg";